module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.f4769f9b.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.eot
 ** module id = 461
 ** module chunks = 0
 **/